export function getTableData() {
  return [{
    phone: '+86 135****1248',
    zhDate: '2023年04月30日',
    date: '2016-05-02',
    name: '王小虎',
    address: '上海市普陀区金沙江路 1518 弄',
    isDispose: false,
    more: false
  }, {
    phone: '+86 135****1248',
    zhDate: '2023年04月30日',
    date: '2016-05-04',
    name: '王小虎',
    address: '上海市普陀区金沙江路 1517 弄',
    isDispose: false,
  }, {
    phone: '+86 135****1248',
    zhDate: '2023年04月30日',
    date: '2016-05-03',
    name: '王小虎',
    address: '上海市普陀区金沙江路 1516 弄',
    isDispose: false
  }, {
    phone: '+86 135****1248',
    zhDate: '2023年04月30日',
    date: '2016-05-03',
    name: '王小虎',
    address: '上海市普陀区金沙江路 1516 弄',
    isDispose: false
  }]
}
// 秒转时分秒
export function getDateTime(time) {
  let h = parseInt(time / 60 / 60 % 24)
  h = h < 10 ? '0' + h : h
  let m = parseInt(time / 60 % 60)
  m = m < 10 ? '0' + m : m
  let s = parseInt(time % 60)
  s = s < 10 ? '0' + s : s
  return `${h}：${m}：${s}`
}

// 下载流文件
export function downloadFile(data, fileName) {
  const blob = new Blob([data]);//new Blob([res])中不加data就会返回下图中[objece objece]内容（少取一层）
  const elink = document.createElement('a');
  elink.download = fileName;
  elink.style.display = 'none';
  elink.href = URL.createObjectURL(blob);
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href); // 释放URL 对象
  document.body.removeChild(elink);
}

//将base64转换为blob
export function dataURLtoBlob(dataurl){  
  var arr = dataurl.split(',')
  //注意base64的最后面中括号和引号是不转译的
  var _arr = arr[1].substring(0, arr[1].length - 2)
  var mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(_arr),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {
    type: mime
  })
} 

// 下载图片
export function downloadImg(url, fileName) {
  var x = new XMLHttpRequest();
  x.open("GET", url, true);
  x.responseType = 'blob';
  x.onload=function(e) {
      var url = window.URL.createObjectURL(x.response)
      var a = document.createElement('a');
      a.href = url
      a.download = fileName;
      a.click()
  }
  x.send();
}


// 计算列表时间展示()
export function getShowDate(startTime, endTime) {
  if (!startTime||!endTime) return {}
  const startYear = startTime.substr(0,4)
  const endYear = endTime.substr(0,4)
  const startMonth = startTime.substr(5,2)
  const endMonth = endTime.substr(5,2)
  const startDay = startTime.substr(8,2)
  const endDay = endTime.substr(8,2)
  // 跨年
  if (startYear !== endYear) {
    return { startTimeBack: startYear+'年', endTimeBack: endYear+'年', type:'year'}
  } else if (startMonth !== endMonth) { // 跨月
    return {timeFront:startYear+'年', startTimeBack: startMonth+'月', endTimeBack: endMonth+'月', type:'month'}
  } else if (startDay !== endDay) { // 跨天
    return {timeFront: startYear+'年'+startMonth+'月', startTimeBack: startDay+'日', endTimeBack: endDay+'日', type:'day'}
  } else { // 跨时
    return {timeFront: startYear+'年'+startMonth+'月'+startDay+'日  ', startTimeBack: startTime.split(' ')[1].substr(0,5), endTimeBack: endTime.split(' ')[1].substr(0,5), type:'hour'}
  }
}

// 计算当前时间与期望时间小时差
export function getHours(endTime) {
  const myTime = endTime.replace('年','-').replace('月','-').replace('日','')
  const time = new Date(myTime).getTime() - new Date().getTime()
  return time/(60*60*1000)
}

export function getTree(arr, Pid) {
  const tree = []
  for (const item of arr) {
    if (item.pid === Pid) {
      const children = getTree(arr, item.id)
      tree.push({
        ...item,
        children: Object.keys(children).length > 0 ? children : null
      })
    }
  }
  return tree
}

export function firstUpperCase([first, ...rest]) {
  return first?.toUpperCase() + rest.join('')
} 